module.exports = __webpack_public_path__ + "static/img/leads-count-red.5249ec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leads-count-red.svg
// module id = 459
// module chunks = 0